import React from "react";

const MeetingIcon = () => {
  return (
    <svg
      width="293"
      height="276"
      viewBox="0 0 293 276"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        cx="147"
        cy="138.112"
        r="136.686"
        stroke="url(#paint0_radial_553_16660)"
        stroke-width="0.914286"
      />
      <circle
        cx="147"
        cy="138.112"
        r="116.571"
        stroke="url(#paint1_radial_553_16660)"
        stroke-width="0.914286"
      />
      <circle
        cx="147"
        cy="138.112"
        r="96.4571"
        stroke="url(#paint2_radial_553_16660)"
        stroke-width="0.914286"
      />
      <g clip-path="url(#clip0_553_16660)">
        <rect
          x="0.600052"
          y="52.8224"
          width="292"
          height="176"
          rx="6.4"
          fill="white"
        />
        <rect
          x="0.600052"
          y="52.8224"
          width="292"
          height="11.2"
          fill="#E4E7EC"
        />
        <ellipse cx="7.80004" cy="59.2225" rx="1.6" ry="1.6" fill="#98A2B3" />
        <ellipse cx="14.2001" cy="59.2225" rx="1.6" ry="1.6" fill="#98A2B3" />
        <ellipse cx="20.6" cy="59.2225" rx="1.6" ry="1.6" fill="#98A2B3" />
        <rect
          x="15.4"
          y="74.0225"
          width="126"
          height="65.6"
          rx="2.8"
          fill="#F9FAFB"
          stroke="#F2F4F7"
          stroke-width="0.8"
        />
        <g clip-path="url(#clip1_553_16660)">
          <path
            d="M78.6 95.2225C77.2319 95.1898 75.8711 95.431 74.5976 95.9319C73.3241 96.4329 72.1636 97.1834 71.1844 98.1395C70.2052 99.0955 69.4271 100.238 68.8959 101.499C68.3646 102.76 68.0909 104.115 68.0909 105.483C68.0909 106.852 68.3646 108.206 68.8959 109.468C69.4271 110.729 70.2052 111.871 71.1844 112.827C72.1636 113.783 73.3241 114.534 74.5976 115.035C75.8711 115.536 77.2319 115.777 78.6 115.744C79.9682 115.777 81.329 115.536 82.6025 115.035C83.876 114.534 85.0365 113.783 86.0157 112.827C86.9949 111.871 87.773 110.729 88.3042 109.468C88.8355 108.206 89.1091 106.852 89.1091 105.483C89.1091 104.115 88.8355 102.76 88.3042 101.499C87.773 100.238 86.9949 99.0955 86.0157 98.1395C85.0365 97.1834 83.876 96.4329 82.6025 95.9319C81.329 95.431 79.9682 95.1898 78.6 95.2225ZM72.7334 121.605C70.0105 121.605 67.3991 122.687 65.4737 124.612C63.5484 126.537 62.4667 129.149 62.4667 131.872V139.196H94.7334V131.872C94.7334 129.149 93.6517 126.537 91.7263 124.612C89.801 122.687 87.1896 121.605 84.4667 121.605H72.7334Z"
            fill="#D0D5DD"
          />
        </g>
        <rect
          x="151.8"
          y="74.0225"
          width="126"
          height="65.6"
          rx="2.8"
          fill="#FCFDFD"
          stroke="#F2F4F7"
          stroke-width="0.8"
        />
        <rect
          x="15.4"
          y="150.022"
          width="126"
          height="65.6"
          rx="2.8"
          fill="#FCFDFD"
          stroke="#F2F4F7"
          stroke-width="0.8"
        />
        <rect
          x="151.8"
          y="150.022"
          width="126"
          height="65.6"
          rx="2.8"
          fill="#F9FAFB"
          stroke="#F2F4F7"
          stroke-width="0.8"
        />
        <g clip-path="url(#clip2_553_16660)">
          <path
            d="M214.6 95.2225C213.232 95.1898 211.871 95.431 210.598 95.9319C209.324 96.4329 208.164 97.1834 207.184 98.1395C206.205 99.0955 205.427 100.238 204.896 101.499C204.365 102.76 204.091 104.115 204.091 105.483C204.091 106.852 204.365 108.206 204.896 109.468C205.427 110.729 206.205 111.871 207.184 112.827C208.164 113.783 209.324 114.534 210.598 115.035C211.871 115.536 213.232 115.777 214.6 115.744C215.968 115.777 217.329 115.536 218.603 115.035C219.876 114.534 221.037 113.783 222.016 112.827C222.995 111.871 223.773 110.729 224.304 109.468C224.835 108.206 225.109 106.852 225.109 105.483C225.109 104.115 224.835 102.76 224.304 101.499C223.773 100.238 222.995 99.0955 222.016 98.1395C221.037 97.1834 219.876 96.4329 218.603 95.9319C217.329 95.431 215.968 95.1898 214.6 95.2225ZM208.733 121.605C206.01 121.605 203.399 122.687 201.474 124.612C199.548 126.537 198.467 129.149 198.467 131.872V139.196H230.733V131.872C230.733 129.149 229.652 126.537 227.726 124.612C225.801 122.687 223.19 121.605 220.467 121.605H208.733Z"
            fill="#D0D5DD"
          />
        </g>
        <g clip-path="url(#clip3_553_16660)">
          <path
            d="M214.6 171.222C213.232 171.19 211.871 171.431 210.598 171.932C209.324 172.433 208.164 173.183 207.184 174.139C206.205 175.096 205.427 176.238 204.896 177.499C204.365 178.76 204.091 180.115 204.091 181.483C204.091 182.852 204.365 184.206 204.896 185.468C205.427 186.729 206.205 187.871 207.184 188.827C208.164 189.783 209.324 190.534 210.598 191.035C211.871 191.536 213.232 191.777 214.6 191.744C215.968 191.777 217.329 191.536 218.603 191.035C219.876 190.534 221.037 189.783 222.016 188.827C222.995 187.871 223.773 186.729 224.304 185.468C224.835 184.206 225.109 182.852 225.109 181.483C225.109 180.115 224.835 178.76 224.304 177.499C223.773 176.238 222.995 175.096 222.016 174.139C221.037 173.183 219.876 172.433 218.603 171.932C217.329 171.431 215.968 171.19 214.6 171.222ZM208.733 197.605C206.01 197.605 203.399 198.687 201.474 200.612C199.548 202.537 198.467 205.149 198.467 207.872V215.196H230.733V207.872C230.733 205.149 229.652 202.537 227.726 200.612C225.801 198.687 223.19 197.605 220.467 197.605H208.733Z"
            fill="#D0D5DD"
          />
        </g>
        <g clip-path="url(#clip4_553_16660)">
          <path
            d="M78.6 171.222C77.2319 171.19 75.8711 171.431 74.5976 171.932C73.3241 172.433 72.1636 173.183 71.1844 174.139C70.2052 175.096 69.4271 176.238 68.8959 177.499C68.3646 178.76 68.0909 180.115 68.0909 181.483C68.0909 182.852 68.3646 184.206 68.8959 185.468C69.4271 186.729 70.2052 187.871 71.1844 188.827C72.1636 189.783 73.3241 190.534 74.5976 191.035C75.8711 191.536 77.2319 191.777 78.6 191.744C79.9682 191.777 81.329 191.536 82.6025 191.035C83.876 190.534 85.0365 189.783 86.0157 188.827C86.9949 187.871 87.773 186.729 88.3042 185.468C88.8355 184.206 89.1091 182.852 89.1091 181.483C89.1091 180.115 88.8355 178.76 88.3042 177.499C87.773 176.238 86.9949 175.096 86.0157 174.139C85.0365 173.183 83.876 172.433 82.6025 171.932C81.329 171.431 79.9682 171.19 78.6 171.222ZM72.7334 197.605C70.0105 197.605 67.3991 198.687 65.4737 200.612C63.5484 202.537 62.4667 205.149 62.4667 207.872V215.196H94.7334V207.872C94.7334 205.149 93.6517 202.537 91.7263 200.612C89.801 198.687 87.1896 197.605 84.4667 197.605H72.7334Z"
            fill="#D0D5DD"
          />
        </g>
      </g>
      <rect
        x="2.60005"
        y="54.8224"
        width="288"
        height="172"
        rx="4.4"
        stroke="#E4E7EC"
        stroke-width="4"
        stroke-linejoin="round"
      />
      <defs>
        <radialGradient
          id="paint0_radial_553_16660"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(147 200.123) rotate(-90) scale(198.99)"
        >
          <stop stop-color="#E4E7EC" />
          <stop offset="1" stop-color="#E4E7EC" stop-opacity="0.13" />
        </radialGradient>
        <radialGradient
          id="paint1_radial_553_16660"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(147 191.028) rotate(-90.639) scale(183.658)"
        >
          <stop stop-color="#E4E7EC" />
          <stop offset="1" stop-color="#E4E7EC" stop-opacity="0.35" />
        </radialGradient>
        <radialGradient
          id="paint2_radial_553_16660"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(147 181.933) rotate(-90.639) scale(152.092)"
        >
          <stop stop-color="#E4E7EC" />
          <stop offset="1" stop-color="#E4E7EC" stop-opacity="0.35" />
        </radialGradient>
        <clipPath id="clip0_553_16660">
          <rect
            x="0.600052"
            y="52.8224"
            width="292"
            height="176"
            rx="6.4"
            fill="white"
          />
        </clipPath>
        <clipPath id="clip1_553_16660">
          <rect
            width="44"
            height="44"
            fill="white"
            transform="translate(56.6 95.2225)"
          />
        </clipPath>
        <clipPath id="clip2_553_16660">
          <rect
            width="44"
            height="44"
            fill="white"
            transform="translate(192.6 95.2225)"
          />
        </clipPath>
        <clipPath id="clip3_553_16660">
          <rect
            width="44"
            height="44"
            fill="white"
            transform="translate(192.6 171.222)"
          />
        </clipPath>
        <clipPath id="clip4_553_16660">
          <rect
            width="44"
            height="44"
            fill="white"
            transform="translate(56.6 171.222)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default MeetingIcon;
